export const vocabMatches = (a, b) => {
  if (!Array.isArray(a) || !Array.isArray(b)) return false;

  const setA = new Set(a);
  const setB = new Set(b);
  if (setA.size !== setB.size) return false;

  for (let word of setA) {
    if (!setB.has(word)) return false;
  }

  return true;
};

  export const shuffleArray = (array) => {
        const arr = [...array]; // copy to avoid mutating original
        for (let i = arr.length - 1; i > 0; i--) {
          const j = Math.floor(Math.random() * (i + 1));
          [arr[i], arr[j]] = [arr[j], arr[i]];
        }
        return arr;
      }

        
           export const shuffleArray2 = (obj1, obj2) => {
                 if (!Array.isArray(obj1) || !Array.isArray(obj2)) return;
                var index = obj1.length;
                var rnd, tmp1, tmp2;
              
                while (index) {
                  rnd = Math.floor(Math.random() * index);
                  index -= 1;
                  tmp1 = obj1[index];
                  tmp2 = obj2[index];
                  obj1[index] = obj1[rnd];
                  obj2[index] = obj2[rnd];
                  obj1[rnd] = tmp1;
                  obj2[rnd] = tmp2;
                }
              }
              

  